/**
 * One limited-mode warning per screen.
 *
 * An unactivated account is refused by every guarded request a page makes, so
 * warning per refusal meant a toast every few seconds for as long as the user
 * sat there - on top of the banner already explaining it on the page. The
 * toast's job is to explain why a screen came up empty, which it does once;
 * moving somewhere else is a new screen and earns a new warning.
 */
let lastWarnedPath: string | null = null

export const shouldWarnOnce = (path: string): boolean => {
  if (path === lastWarnedPath) return false
  lastWarnedPath = path
  return true
}

/** Test seam: forget which screen was warned about. */
export const resetLimitedModeWarning = (): void => {
  lastWarnedPath = null
}
